import { ref } from 'vue'

export default function useToolModels() {
  const toolModels = ref([
    { value: 'gpt-4o-mini', label: 'GPT-4o mini' },
    { value: 'gpt-4o', label: 'GPT-4o' },
    { value: 'gpt-5-nano', label: 'GPT-5 nano' },
    { value: 'gpt-5-mini', label: 'GPT-5 mini' },
    { value: 'gpt-5', label: 'GPT-5' }
  ])

  return {
    toolModels
  }
}